<template>
    <div>
        <div>
            <!--<div class="card-title">
                <b-button variant="outline-secondary" @click="$emit('back')">
                    <i class="fas fa-arrow-left"></i>
                </b-button>
                &nbsp;
                Edit Selected Sop
            </div>
            -->
            <div v-show="false">
                <div class="px-3">
                    <!-- @callbackRange="onChange" -->
                    <vue-slide-bar
                    ref="slider"
                    :data="slider_config.data"
                    :range="slider_config.range" />
                </div>
            </div>
        </div>

        <!-- only show this button when the details tab is hidden -->
        <!--
        <b-row>
            <b-col class="mb-1">
                <b-button v-if="!rightCardExpanded" variant="outline-primary" style="float: right;" size="sm" @click="rightCardExpanded = !rightCardExpanded">
                    <i :class="arrowDirection" class="fas"></i>
                    &nbsp;
                    Expand Details
                </b-button>
            </b-col>
        </b-row>
        -->
        <!-- -- -->
        <b-row v-if="hasMounted">
            <b-col cols="12">
                <b-card>
                    <b-row>
                        <b-col cols="12">
                            <p class="card-title">
                                <b-button size="sm" variant="outline-secondary" @click="$emit('back')">
                                    <i class="fas fa-arrow-left"></i>
                                </b-button>
                                <b-button style="float: right;" size="sm" variant="outline-primary" v-b-toggle.collapse-3 class="mb-2 mt-0 me-auto">
                                    Toggle Collapse
                                </b-button>
                                <b-button v-if="!rightCardExpanded" variant="outline-primary" class="mb-2 mt-0 me-1" style="float: right;" size="sm" @click="rightCardExpanded = !rightCardExpanded">
                                    Expand Details
                                </b-button>
                            </p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <b-collapse visible id="collapse-3">
                                <div class="document_header" v-html="header_html"></div>
                            </b-collapse>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col :cols="colWidth.col0">
                <b-card>
                    <div class="card-title">
                        Details
                        <b-button
                        v-b-toggle.details
                        style="float: right;"
                        class="me-auto" size="sm"
                        variant="outline-dark"><i class="fas fa-expand-alt"></i></b-button>
                    </div>
                    <b-collapse visible id="details">
                        ----
                        -------
                        -----
                        --
                        ---
                        ---------
                        ---
                    </b-collapse>
                </b-card>

                <b-card v-if="isAdmin">
                    <div class="card-title">
                        Merge Keys
                        <b-button
                        v-b-toggle.merge-keys
                        style="float: right;"
                        class="me-auto" size="sm"
                        variant="outline-dark"><i class="fas fa-expand-alt"></i></b-button>
                    </div>
                    <b-collapse visible id="merge-keys">
                        <table class="merge-table tableT">
                            <tbody>
                                <tr>
                                    <td style="font-weight: bold; width: 20%;">Item</td>
                                    <td style="font-weight: bold;">Key</td>
                                </tr>

                                <tr>
                                    <td>Date</td>
                                    <td @click="insertKeyValue" class="key-hover">##current_date##</td>
                                </tr>
                                
                            </tbody>
                        </table>
                    </b-collapse>
                </b-card>
            </b-col>
            <b-col :cols="colWidth.col1">
                <div class="document-editor">
                    <div class="document-editor__toolbar"></div>
                    <div class="document-editor__editable-container">
                        <div class="document-editor__editable">
                            <!--<p>{{selected_sop_body}}</p>-->
                            <p v-html="selected_sop_body"></p>
                        </div>
                    </div>
                </div>
            </b-col>
            <b-col :cols="colWidth.col2" v-if="rightCardExpanded">
                <CheckList/>
                <b-card>
                    <div>
                        <b-button variant="outline-primary" style="float: right;" size="sm" @click="rightCardExpanded = !rightCardExpanded">
                            Hide 
                            &nbsp;
                            <i :class="arrowDirection" class="fas"></i>
                        </b-button>
                        <div class="card-title">
                            Details
                        </div>
                        <div class="mt-4">
                            <p>Some</p>
                            <p>document</p>
                            <p>related</p>
                            <p>details</p>
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { clientAdminState } from '@/state/helpers'
import VueSlideBar from "vue-slide-bar";
//import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document"
//import DecoupledEditor from "../../../plugin/ckeditor-custom/ckeditor.js"
import CheckList from './sopChecklist.vue'
export default {
    data:() => ({
        editor: null,
        rightCardExpanded: true,
        hasMounted: false,
        sop_body: [
            {
                body: `
                    <p></p>
                `,
                date: '12/12/2020',
                revision: '1'
            },
            {
                body: '222 222 222 222',
                date: '14/12/2020',
                revision: '2'
            },
            {
                body: '333 333 333 333 333 333 333 333 333 333 333 333',
                date: '16/12/2020',
                revision: '3'
            },
            {
                body: '444',
                date: '18/12/2020',
                revision: '4'
            }
        ],
        slider_config: {
            value: 1,
            data: [1, 2, 3, 4],
            range: [
                {
                    label: "Revision 1"
                },
                {
                    label: "Revision 1.2"
                },
                {
                    label: "Revision 2"
                },
                {
                    label: "Revision 3"
                },
            ]
        },
    }),
    components:{
        VueSlideBar,CheckList
    },
    computed:{
        ...clientAdminState,
        header_html(){
            return `<table style="width: 100%;">
            <tr>
                <td colspan="2" style="width: 50%;">
                    <img :src="company_logo" alt="Company Logo" height="100"/>
                </td>
                <td colspan="2" style="width: 50%; text-align: center;" >
                    <span style="font-size: 2rem;color: red;">
                        {{doc_heading}}</span>
                </td>
            </tr>
            
            <tr class="bold-text">
                <td colspan="4">{{doc_name}}</td>
            </tr>

            <tr class="bold-text">
                <td colspan="3" style="">{{doc_description}}</td>
                <td colspan="1" style="">Page x of x</td>
            </tr>

            <tr class="bold-text">
                <td style="" >SOP No:</td>
                <td style="" >{{sop_number}}</td>
                <td style="" >Effective Date</td>
                <td style="" >{{effective_date}}</td>
            </tr>

            <tr class="bold-text">
                <td style="" >Revision No:</td>
                <td style="" >{{revision_number}}</td>
                <td style="" >Supersedes</td>
                <td style="" >{{supersedes}}</td>
            </tr>

            <tr class="bold-text">
                <td style="" >Revise By</td>
                <td style="" >{{revise_by_date}}</td>
            </tr>
        </table>`
        },
        isAdmin(){
            //* is user a ccb admin
            let show = false;
            if(this.core_data != null){
                show = this.core_data.ccb_admin
            }
            return show;
        },
        selected_sop_body(){
            if(this.$refs.slider != undefined){
                let index = this.$refs.slider.currentIndex;
                return this.sop_body[index].body;
            }
            else{
                return '';
            }
        },
        colWidth(){
            if(this.rightCardExpanded){
                return {col0: 2,col1: 8, col2: 2}
            }
            else{
                return {col0: 2,col1: 10, col2: 0}
            }
        },
        arrowDirection(){
            if(this.rightCardExpanded){
                return 'fa-arrow-right'
            }
            else{
                return 'fa-arrow-left'
            }
        },
    },
    methods:{
        /* eslint-disable-next-line */
        onChange(a){
            return false;
        },
        /*initEditor(){
            DecoupledEditor
            .create( document.querySelector( '.document-editor__editable' ),{
                table: {
                    contentToolbar: [
                        'tableColumn', 'tableRow', 'mergeTableCells',
                        'tableProperties', 'tableCellProperties'
                    ],
                    tableProperties: {},

                    tableCellProperties: {}
                }
            })
            .then( editor => {
                const toolbarContainer = document.querySelector( '.document-editor__toolbar' );
                toolbarContainer.appendChild( editor.ui.view.toolbar.element );
                this.editor = editor;
            })
            .catch( err => {
                console.error( err );
            });
        },*/
        //* ck editor methods
        insertKeyValue(){
            this.editor.change( writer => {
                const pos = this.editor.model.document.selection.getFirstPosition();
                writer.insertText( 'tester', pos );
            })
        }
    },
    mounted(){
        this.hasMounted = true;
        this.$nextTick(()=>{
            //this.initEditor();
        })
    },
}
</script>

<style>
.vue-slide-bar-separate-text{
    color: black;
    font-weight: bold;
}

.merge-table{
    width: 100%;
}
.key-hover:hover{
    text-decoration: underline;
    color: dodgerblue;
    cursor: pointer;
}


table, th, td {
    border: 1px solid black;
  }
  #table.tableT{
    width: 100%;
  }
.document_header{
    /*margin-left: calc( 2 * var(--ck-spacing-large) );
    margin-right: calc( 2 * var(--ck-spacing-large) );*/
}

.document-editor {
    border: 1px solid var(--ck-color-base-border);
    border-radius: var(--ck-border-radius);

    /* Set vertical boundaries for the document editor. */
    max-height: 450px;

    /* This element is a flex container for easier rendering. */
    display: flex;
    flex-flow: column nowrap;
}

.document-editor__toolbar {
    /* Make sure the toolbar container is always above the editable. */
    z-index: 1;

    /* Create the illusion of the toolbar floating over the editable. */
    /*box-shadow: 0 0 5px hsla( 0,0%,0%,.2 );*/

    /* Use the CKEditor CSS variables to keep the UI consistent. */
    border-bottom: 1px solid var(--ck-color-toolbar-border);
}

/* Adjust the look of the toolbar inside the container. */
.document-editor__toolbar .ck-toolbar {
    border: 0;
    border-radius: 0;
}

.document-editor__editable-container {
    padding: calc( 2 * var(--ck-spacing-large) );
    background: var(--ck-color-base-foreground);
    
    /* Make it possible to scroll the "page" of the edited content. */
    overflow-y: scroll;
    max-height: 60vh;
    /*border: 10px solid red !important;*/
}

.document-editor__editable-container .ck-editor__editable {
    /* Set the dimensions of the "page". */
    width: 90%;
    min-height: 21cm;

    /* Keep the "page" off the boundaries of the container. */
    padding: 0.5cm 1cm 1cm;

    border: 1px hsl( 0,0%,82.7% ) solid;
    border-radius: var(--ck-border-radius);
    background: white;

    /* The "page" should cast a slight shadow (3D illusion). */
    box-shadow: 0 0 5px hsla( 0,0%,0%,.1 );

    /* Center the "page". */
    margin: 0 auto;
}

/* Adjust the headings dropdown to host some larger heading styles. */
.document-editor .ck-heading-dropdown .ck-list .ck-button__label {
    line-height: calc( 1.7 * var(--ck-line-height-base) * var(--ck-font-size-base) );
    min-width: 6em;
}

/* Scale down all heading previews because they are way too big to be presented in the UI.
Preserve the relative scale, though. */
.document-editor .ck-heading-dropdown .ck-list .ck-button:not(.ck-heading_paragraph) .ck-button__label {
    transform: scale(0.8);
    transform-origin: left;
}

/* Set the styles for "Heading 1". */
.document-editor .ck-content h2,
.document-editor .ck-heading-dropdown .ck-heading_heading1 .ck-button__label {
    font-size: 2.18em;
    font-weight: normal;
}

.document-editor .ck-content h2 {
    line-height: 1.37em;
    padding-top: .342em;
    margin-bottom: .142em;
}

/* Set the styles for "Heading 2". */
.document-editor .ck-content h3,
.document-editor .ck-heading-dropdown .ck-heading_heading2 .ck-button__label {
    font-size: 1.75em;
    font-weight: normal;
    color: hsl( 203, 100%, 50% );
}

.document-editor .ck-heading-dropdown .ck-heading_heading2.ck-on .ck-button__label {
    color: var(--ck-color-list-button-on-text);
}

/* Set the styles for "Heading 2". */
.document-editor .ck-content h3 {
    line-height: 1.86em;
    padding-top: .171em;
    margin-bottom: .357em;
}

/* Set the styles for "Heading 3". */
.document-editor .ck-content h4,
.document-editor .ck-heading-dropdown .ck-heading_heading3 .ck-button__label {
    font-size: 1.31em;
    font-weight: bold;
}

.document-editor .ck-content h4 {
    line-height: 1.24em;
    padding-top: .286em;
    margin-bottom: .952em;
}

/* Set the styles for "Paragraph". */
.document-editor .ck-content p {
    font-size: 1em;
    line-height: 1.63em;
    padding-top: .5em;
    margin-bottom: 1.13em;
}

/* Make the block quoted text serif with some additional spacing. */
.document-editor .ck-content blockquote {
    font-family: Georgia, serif;
    margin-left: calc( 2 * var(--ck-spacing-large) );
    margin-right: calc( 2 * var(--ck-spacing-large) );
}
</style>